import { Component, EventEmitter, inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { UserRaw } from '../../models/user.model';
import { UserService } from '../../services/user.service';
import {
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RdsCheckboxModule,
    RdsProgressSpinnerComponent,
    RdsDrawerActionsDirective, 
    RdsRadioButtonModule,
} from '@rds/angular-components';

export type FormValidity = "valid" | "warning" | "invalid_priority" | "required" | "delete" | "error";

type UserForm = FormGroup<{
  email: FormControl<string | null>;
  unixID: FormControl<string | null>;
  roleID: FormControl< 1 | 2 | 3 | 4 | null>;
}>

@Component({
  selector: 'app-user-form',
  standalone: true,
    imports: [
    ReactiveFormsModule,
    RdsButtonModule,
    RdsIconsModule,
    RdsFormFieldModule,
    RdsCheckboxModule,
    RdsProgressSpinnerComponent,
    RdsDrawerActionsDirective,
    RdsRadioButtonModule
],
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent implements OnInit, OnChanges {
  @Input() selectedUser: UserRaw | null = null;
  @Input() isLoadingChanges: boolean = false;

  @Output() submitUser = new EventEmitter<{data: UserRaw, valid: FormValidity}>();
  @Output() deleteUser = new EventEmitter<UserRaw>();
  @Output() cancelForm = new EventEmitter<void>();

  fb = inject(FormBuilder)
  userForm!: UserForm;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.setupForm()
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedUser']) {
      this.setupForm()
    }
  }

  private setupForm() {
    const u = this.selectedUser || {} as UserRaw;
    this.userForm = this.fb.group({
      unixID: [{value: u.unixID, disabled: true}, Validators.required],
      email: [u.email, [Validators.required, Validators.email]],
      roleID: [u.roleID as 1 | 2 | 3 | 4, Validators.required],
    }) as UserForm;

    if (this.selectedUser) {
      this.userForm.patchValue(this.selectedUser);
    }
  }

  resetForm() {
    this.userForm.reset({
      email: '',
      unixID: '',
      roleID: 1,
    });
  }

  onKeywordKeypress(e: KeyboardEvent) {
    if (e.code == "Enter") {
      e.preventDefault()
    }
  }

  onSubmit() {
    if (this.userForm.valid) {
      const formData = this.userForm.value as UserRaw;
      this.submitUser.emit({
        data: formData,
        valid: 'valid'
      });
      this.userService.notifySubmitUser({ data: formData, valid: 'valid' })
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  onDelete() {
    if (this.selectedUser) {
      this.deleteUser.emit(this.selectedUser);
    }
  }

}
